import {connect} from "react-redux";
import CarServiceAccountList from "./List";
import {bindActionCreators} from "redux";
import {accountList} from "../../../../service/Valet/action";
import {getCityByStateId} from "../../../../service/Account/action";
import {accountFilter} from "../../../../service/CarService/action";

const mapStateToProps = (state) => ({
    accountDetails:state.Valet.accountListDetails,
    geoCity:state.Dropdown.geoCity,
    accountFilterContent:state.CarService.accountFilter,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            accountList,
            getCityByStateId,
            accountFilter
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(CarServiceAccountList);
